import themeColors from "kz-ui-sdk/dist/theme.config.js";

export const BrandThemeConfigs = {
  xo268: themeColors["dark-purple"],
  wow69: themeColors["black-gold"],
  "789bk": themeColors["dark-purple"],
  default: themeColors["dark-purple"],
  mk69: themeColors["pink-pulse"],
  dee99: themeColors["black-gold"],
  hk39: themeColors["dark-purple"],
};
